import React from 'react';
import { Link } from 'components';
import classNames from 'classnames';

function ProfileNavigationItem({ to, children, isSelected, ...props }) {
	return (
		<li className="Secondary-Navigation-item">
			<Link
				kind="unstyled"
				to={to}
				className={classNames('CTA CTA--text--dark', {
					'is-selected': isSelected,
				})}
				{...props}
			>
				{children}
			</Link>
		</li>
	);
}

export default ProfileNavigationItem;
